import React from 'react';

// Types
import { GoalItem } from 'Shared/constants/types';
import { useTranslation } from 'Shared/utils/hooks/use-translation';
import { useGoal } from 'Shared/utils/hooks/use-goal';

// Utils
import { dateMMDDYY } from 'Shared/utils/DateTime.utils';

// Components
import { WpAlert } from 'Wpds/components/alert';

// Styles
import './GoalCompleteAlert.scss';

type Props = {
  goal: GoalItem;
};

const GoalCompleteAlert = ({ goal }: Props) => {
  const { tr } = useTranslation();
  const { isComplete, completedBy } = useGoal({ slug: goal.slug });
  const completedAt = dateMMDDYY(goal?.completedAt);
  const goalResolutionNote = goal?.resolutionNote;

  if (!isComplete) return null;

  const baseClassName = 'GoalCompleteAlert';

  return (
    <WpAlert type="success" iconPlacement="top">
      <div className={baseClassName}>
        <div className={`${baseClassName}__title`}>
          {completedBy
            ? tr('perform.goals.complete_alert.marked_complete_with_user', completedAt, completedBy.displayName)
            : tr('perform.goals.complete_alert.marked_complete_without_user', completedAt)}
        </div>
        {goalResolutionNote && (
          <>
            <div className={`${baseClassName}__note`}>{tr('perform.goals.complete_alert.resolution_notes')}</div>
            <div>{goalResolutionNote}</div>
          </>
        )}
      </div>
    </WpAlert>
  );
};

export default GoalCompleteAlert;
